export default "__VITE_ASSET__1b6d434e__"